import classNames from 'classnames';
import type { CSSProperties } from 'react';

import { getDimmedPlotColor, useChartTheme } from '../../utilities';
import styles from './legend.module.css';

type LegendItem = {
  label: string;
  color: string;
};

export type LegendProps = {
  items: LegendItem[];
  formatLabel?: (label: string) => string;
  marker?: 'square' | 'line';
  highlightedLabel?: string | null;
};

export const Legend = ({
  items,
  formatLabel,
  marker = 'square',
  highlightedLabel = null,
}: LegendProps) => {
  const { theme } = useChartTheme();
  return (
    <div className={styles.legend}>
      {items.map(({ label, color }) => {
        const formattedLabel = formatLabel ? formatLabel(label) : label;
        const dimmed = highlightedLabel !== null && highlightedLabel !== label;

        return (
          <div
            key={`legend-${label}`}
            className={classNames(styles.legendItem, {
              [styles.legendItemDimmed ?? '']: dimmed,
            })}
          >
            <span
              className={classNames({
                [styles.legendSwatchSquare ?? '']: marker === 'square',
                [styles.legendSwatchLine ?? '']: marker === 'line',
              })}
              style={
                {
                  backgroundColor: color,
                  '--replots-dim-color': getDimmedPlotColor(color, theme),
                } as CSSProperties
              }
            />
            <span title={label} className={styles.legendLabel}>
              {formattedLabel}
            </span>
          </div>
        );
      })}
    </div>
  );
};
